import request from '@/utils/request'

export function submitMessage(data) {
  return request({
    url: '/pc/message/submit',
    method: 'post',
    data
  })
}
